// Unity Services Dashboard base URLs by environment. Only staging and
// production are publicly reachable, so dev/test point at staging.
const DASHBOARD_URLS = {
  DEVELOPMENT: 'https://staging.cloud.unity.com',
  TEST: 'https://staging.cloud.unity.com',
  STAGING: 'https://staging.cloud.unity.com',
  PRODUCTION: 'https://cloud.unity.com',
} as const;

export type BuildManageSeatUrlArgs = {
  env: string | undefined;
  // Required: My Products is org-scoped. Callers must guard for a missing org
  // before building the URL (see useUpmProductDetailPage / useMyAssetsPage).
  organizationId: string;
};

// "Manage seat" sends the user to the dashboard's My Products (inventory) page
// for the given organization, where seats are managed.
export const buildManageSeatUrl = ({
  env,
  organizationId,
}: BuildManageSeatUrlArgs): string => {
  const envKey = (env ?? 'staging')
    .trim()
    .toUpperCase() as keyof typeof DASHBOARD_URLS;
  const baseUrl = DASHBOARD_URLS[envKey] ?? DASHBOARD_URLS.STAGING;
  return `${baseUrl}/organizations/${encodeURIComponent(organizationId)}/commerce/my-products`;
};

// Opens the Manage seat URL in a new tab. Don't pass `noopener` in the features
// string: with it, window.open returns null even on success, so we can't tell a
// real block apart from a normal open. Open plainly, sever the opener ourselves
// for tabnabbing safety, and only fall back to same-tab nav when the popup was
// actually blocked.
export const openManageSeatUrl = (url: string): void => {
  const opened = window.open(url, '_blank');
  if (opened) {
    opened.opener = null;
  } else {
    window.location.assign(url);
  }
};
